// Polyfills for Jest test environment and browser
// This file must be loaded before any other setup files

// Polyfill for TextEncoder/TextDecoder required by undici and other modern packages in Jest
if (typeof global !== 'undefined' && typeof global.TextEncoder === 'undefined') {
  const { TextEncoder, TextDecoder } = require('util');
  global.TextEncoder = TextEncoder;
  global.TextDecoder = TextDecoder;
}

// Polyfill for Node.js Buffer in browser environment
if (typeof window !== 'undefined') {
  const { Buffer } = require('buffer');
  // Make Buffer available globally
  window.Buffer = Buffer;
  // eslint-disable-next-line no-undef
  globalThis.Buffer = Buffer;
}
